@if (form) {
  <div class="modal-content" *let="isWorkspaceRenaming$ | async as renaming">
    <div class="modal-header">
      <h5 class="modal-title pull-left">{{ title }}</h5>
      <mat-icon
        (click)="onCancel()"
        [ngClass]="{ disabled: !!renaming }"
        svgIcon="close"
      ></mat-icon>
    </div>

    <div class="modal-body" [formGroup]="form">
      <div class="row">
        <div class="col-sm-4 col-md-3 control-label">
          {{ 'workspaces.workspaceName' | transloco }}
        </div>
        <div class="col">
          <app-input
            placeholder="{{ 'workspaces.workspaceName' | transloco }}"
            formControlName="name"
          ></app-input>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      @if (canWrite) {
      <app-button
        [type]="btnTypes.Flat"
        label="{{ 'buttons.save' | transloco }}"
        [disabled]="form.invalid || !!renaming"
        [size]="btnSizes.Basic"
        (onClick)="onConfirm()"
      ></app-button>
      }
      <app-button
        [type]="btnTypes.Stroked"
        label="{{ 'buttons.cancel' | transloco }}"
        [disabled]="!!renaming"
        [size]="btnSizes.Basic"
        (onClick)="onCancel()"
      ></app-button>
    </div>
  </div>
}
